import React, { useState, useEffect } from 'react'
import LoadingBlock from "@/_mobile/Loading/LoadingBlock"
import i18n from '@/i18n';

const OverlayUI = () => {
    const [isFileDownloading, setIsFileDownloading] = useState(false)
    const [fileDownloadProgress, setFileDownloadProgress] = useState(0)

    useEffect(() => {
        if (window.setCustomEventListener) {
            window.setCustomEventListener('download_start', () => {
                setFileDownloadProgress(0)
                setIsFileDownloading(true)
            })
            window.setCustomEventListener('download_progress', param => {
                const { BytesReceived, TotalBytesToReceive } = param
                setFileDownloadProgress(Math.floor((BytesReceived / TotalBytesToReceive) * 100))
            })
            window.setCustomEventListener('download_finish', param => {
                // const { isNewFile } = param
                setIsFileDownloading(false)
            })
            window.setCustomEventListener('multi_download_start', () => {
                setIsFileDownloading(true)
            })
            window.setCustomEventListener('multi_download_progress', param => {
                const { totalCount, compCount, progress } = param

                // 비동기 처리이기 때문에 progress가 더 낮은 값을 더 늦게 받는 경우를 걸러내기 위함
                if (fileDownloadProgress < Math.floor(progress)) {
                    setFileDownloadProgress(Math.floor(progress))
                }
            })
            window.setCustomEventListener('multi_download_finish', () => {
                setIsFileDownloading(false)
            })
        }

        return () => {
            if (window.removeCustomEventListener) {
                window.removeCustomEventListener('download_start')
                window.removeCustomEventListener('download_progress')
                window.removeCustomEventListener('download_finish')

                window.removeCustomEventListener('multi_download_start')
                window.removeCustomEventListener('multi_download_progress')
                window.removeCustomEventListener('multi_download_finish')
            }
        }
    }, [])

    return <>
        <LoadingBlock open={isFileDownloading}>{i18n.t("mobile.downloading") + `... (${fileDownloadProgress}%)`}</LoadingBlock>
    </>
}

export default OverlayUI;